import { StateCreator, create } from 'zustand';
import { persist } from 'zustand/middleware';

interface MenuStore {
    isDrawerOpen: boolean;
    toggleDrawer: () => void;
    setIsDrawerOpen: (newValue: boolean) => void;
    isAdminMode: boolean;
    toggleAdminMode: () => void;
    setIsAdminMode: (newValue: boolean) => void;
}

const menuSlice: StateCreator<MenuStore, [["zustand/persist", unknown]]> = (
    (set) => ({
        isDrawerOpen: true,
        toggleDrawer: () => set((state) => ({ isDrawerOpen: !state.isDrawerOpen })),
        setIsDrawerOpen: (newValue: boolean) => set({ isDrawerOpen: newValue }),
        isAdminMode: false,
        toggleAdminMode: () => set((state) => ({ isAdminMode: !state.isAdminMode })),
        setIsAdminMode: (newValue: boolean) => set({ isAdminMode: newValue }),

    }));

// Crear store con estados y acciones, y persistencia
const useMenuStore = create<MenuStore>()(
    persist(menuSlice,
        {
            name: 'menu-storage', // nombre del storage (key de localStorage)
            getStorage: () => localStorage, // define donde se guarda el estado
        }
    )
);

export default useMenuStore;
